<template>
  <v-dialog
    v-model="offerAgreementNotAccepted"
    persistent
    width="830"
    style="z-index: 20000000; position: relative"
    :key="Number(offerAgreementNotAccepted)"
  >
    <transition :duration="150">
      <div class="edit" v-if="dialog2">
        <h5 class="f30 textStart">
          {{ localStorage.translations.pages['setting-offer_agreement']['dialog-confirm'].titles }}
        </h5>
        <div class="text" v-html="offerAgreementUserShow[$cookies.get('languageSelect').id]"></div>
        <v-checkbox
          v-model="checkbox"
          :label="localStorage.translations.pages.common.checkbox['user_agreement_confrirm']"
          class="checkbox"
        ></v-checkbox>
        <div class="buttons">
          <button class="customBtn" :class="{ disabled: !checkbox }" @click="confirm(1)">
            {{
              localStorage.translations.pages['setting-offer_agreement']['dialog-confirm-buttons']
                .confirm
            }}
          </button>
          <button
            class="customBtn reverse"
            @click="
              notConfirm = true
              confirm(0)
              dialog2 = false
              dialog = true
            "
          >
            {{
              localStorage.translations.pages['setting-offer_agreement']['dialog-confirm-buttons']
                .not_confirm
            }}
          </button>
        </div>
      </div>
      <div class="edit" v-if="dialog">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 48C19.6562 48 15.6406 46.9297 11.9531 44.7891C8.26562 42.6484 5.35156 39.7344 3.21094 36.0469C1.07031 32.3594 0 28.3438 0 24C0 19.6562 1.07031 15.6406 3.21094 11.9531C5.35156 8.26562 8.26562 5.35156 11.9531 3.21094C15.6406 1.07031 19.6562 0 24 0C28.3438 0 32.3594 1.07031 36.0469 3.21094C39.7344 5.35156 42.6484 8.26562 44.7891 11.9531C46.9297 15.6406 48 19.6562 48 24C48 28.3438 46.9297 32.3594 44.7891 36.0469C42.6484 39.7344 39.7344 42.6484 36.0469 44.7891C32.3594 46.9297 28.3438 48 24 48ZM24 39C24.8438 39 25.5547 38.7109 26.1328 38.1328C26.7109 37.5547 27 36.8516 27 36.0234C27 35.1953 26.7031 34.4844 26.1094 33.8906C25.5156 33.2969 24.8125 33 24 33C23.1875 33 22.4844 33.2969 21.8906 33.8906C21.2969 34.4844 21 35.1953 21 36.0234C21 36.8516 21.2891 37.5547 21.8672 38.1328C22.4453 38.7109 23.1562 39 24 39ZM24 9C22.3438 9 20.9297 9.58594 19.7578 10.7578C18.5859 11.9297 18 13.3438 18 15L21 27C21 27.8438 21.2969 28.5547 21.8906 29.1328C22.4844 29.7109 23.1875 30 24 30C24.8125 30 25.5156 29.7109 26.1094 29.1328C26.7031 28.5547 27 27.8438 27 27L30 15C30 13.3438 29.4141 11.9297 28.2422 10.7578C27.0703 9.58594 25.6562 9 24 9Z"
            fill="#EB5757"
          />
        </svg>

        <h5 class="f18">
          {{ localStorage.translations.pages.common.text.access_site_limited }}
        </h5>
        <div class="buttons">
          <button
            class="customBtn"
            @click="
              dialog2 = true
              dialog = false
            "
          >
            {{
              localStorage.translations.pages['setting-offer_agreement']['dialog-confirm'].titles
            }}
          </button>
          <button class="customBtn reverse" @click="logout()">
            {{ localStorage.translations.pages.auth.buttons.vyhod }}
          </button>
        </div>
      </div>
    </transition>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'OfferAgreementUserShowModal',
  components: {},
  props: ['id', 'name'],
  data() {
    return {
      dialog: false,
      dialog2: false,
      notConfirm: false,
      checkbox: false,
    }
  },
  computed: {
    ...mapGetters('offerAgreement', ['offerAgreementUserShow', 'offerAgreementNotAccepted']),
  },
  watch: {
    offerAgreementNotAccepted() {
      this.checkModalStatus()
    },
  },
  mounted() {
    this.checkModalStatus()
  },
  methods: {
    ...mapMutations('offerAgreement', ['setOfferAgreementNotAccepted']),
    ...mapActions('offerAgreement', ['onOfferAgreementUserShow', 'onOfferAgreementUserSign']),
    ...mapActions('user', ['getUser']),
    checkModalStatus() {
      if (this.offerAgreementNotAccepted === true) {
        this.openModal()
      } else if (this.offerAgreementNotAccepted === false && this.dialog === true) {
        this.closeModal()
      }
    },
    logout() {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'Login' }).catch(() => {})
      })
    },
    openModal() {
      this.dialog2 = true
      this.onOfferAgreementUserShow()
    },
    closeModal() {
      this.dialog = false
      this.dialog2 = false
    },
    async confirm(confirmed) {
      let data = {
        confirmed: confirmed,
        interface_language_id: this.$cookies.get('languageSelect').id,
      }
      this.onOfferAgreementUserSign(data)
        .then(() => {
          if (!this.notConfirm) {
            this.closeModal()
          }
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$store.dispatch(
              'popup/onMessage',
              {
                message: this.localStorage.translations.pages.common.notifications['oshibka'],
                IsError: true,
              },
              { root: true },
            )
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.edit {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  padding: 60px;
  position: relative;
  display: grid;
  justify-content: center;
  justify-items: center;
  grid-template-columns: 1fr;
  svg {
    margin-bottom: 24px;
  }
  h5 {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    &.textStart {
      text-align: start;
    }
  }

  .text {
    width: 100%;
    text-align: start;
    max-height: 435px;
    overflow-y: auto;
    margin-bottom: 40px;
  }
  .checkbox {
    justify-self: flex-start;
  }
  .buttons {
    display: grid;
    grid-template-columns: repeat(2, max-content);
    justify-content: center;
    column-gap: 20px;
  }
}
</style>
